export const isClaimingFunctionEnabled = (
	minVisitCountForEncouragingRereservation?: number
) => {
	return (minVisitCountForEncouragingRereservation ?? 0) >= 1
}

// 再予約案内区間 [minVisitCountForEncouragingRereservation, minVisitCountForNothing) が存在するか
export const isEncouragingRereservationEnabled = (
	minVisitCountForEncouragingRereservation: number,
	minVisitCountForNothing: number
) => {
	return minVisitCountForEncouragingRereservation < minVisitCountForNothing
}

// 手動請求区間 [minVisitCountForManuallyClaimingCancelFee, minVisitCountForEncouragingRereservation) が存在するか
export const isManuallyClaimingEnabled = (
	minVisitCountForManuallyClaimingCancelFee: number,
	minVisitCountForEncouragingRereservation: number
) => {
	return (
		minVisitCountForManuallyClaimingCancelFee <
		minVisitCountForEncouragingRereservation
	)
}
